import React from 'react'
import { Link } from 'react-router-dom'
import { Fade } from "react-awesome-reveal";
import icon from '../../images/icon/plus-icon.png'
import about1 from '../../images/icon/airdrop.png'
import about2 from '../../images/icon/people.png'
import about3 from '../../images/icon/microphone.png'

const About = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section id="about" className="about m-lr">
            <div className="about-wrapper sec-bg pos-rel pb-130 pt-130">
                <div className="container">
                    <div className="sec-title--two text-center">
                        <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                            <div className="sub-title wow fadeInDown" data-wow-duration="600ms">
                                <img src={icon} alt=""/> Viemos para somar
                            </div>
                        </Fade>
                        <Fade direction='down' triggerOnce={'false'} duration={1500} delay={9}>
                            <h2 className="title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">Transformando negócios através<br></br>da tecnologia na nuvem.</h2>
                        </Fade>
                    </div>
                    <div className="row p-4">
                        <div className="col-lg-6 mt-50">
                            <div className="about-left">
                                <h2 className="title">Nossos Valores</h2>
                                <div className="about-item_box ul_li">
                                    <div className="xb-item--icon"><img src={about1} alt="" /></div>
                                    <div className="xb-item--holder">
                                        <p className="xb-item--content"><span>Inovação:</span> Utilizamos tecnologias
                                            de ponta para manter sua empresa na vanguarda da transformação digital.</p>
                                    </div>
                                </div>
                                <div className="about-item_box ul_li">
                                    <div className="xb-item--icon"><img src={about2} alt="" /></div>
                                    <div className="xb-item--holder">
                                        <p className="xb-item--content"><span>Foco no Cliente:</span> Seu sucesso é nossa
                                            prioridade; desenvolvemos soluções personalizadas para maximizar resultados.</p>
                                    </div>
                                </div>
                                <div className="about-item_box ul_li">
                                    <div className="xb-item--icon"><img src={about3} alt="" />
                                    </div>
                                    <div className="xb-item--holder">
                                        <p className="xb-item--content"><span>Transparência:</span> Comunicação clara,
                                            relatórios honestos e total visibilidade em cada etapa do projeto.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 mt-50">
                            <div className="about-right">
                                <div className="xb-item--holder">
                                    <h3 className="xb-item--title">Nossa Missão</h3>
                                    <p className="xb-item--content">Nossa missão é impulsionar a transformação digital
                                        das empresas através de soluções em nuvem de excelência, oferecendo serviços
                                        seguros, escaláveis e com investimento competitivo no mercado.</p>
                                </div>
                                <div className="xb-item--holder">
                                    <h3 className="xb-item--title">Nossa Visão</h3>
                                    <p className="xb-item--content">Ser reconhecida como a empresa líder em Cloud Services
                                        no Brasil, conhecida pela excelência técnica, confiabilidade e por oferecer
                                        soluções que agregam valor real aos negócios dos nossos clientes.</p>
                                </div>
                            </div>
                        </div>
                        <div className="xb-btn text-center mt-90 wow fadeInUp" data-wow-duration="600ms">
                            <Fade direction='up' triggerOnce={'false'} duration={1500} delay={9}>
                                <Link onClick={ClickHandler} to="/about" className="thm-btn thm-btn--aso">Conheça mais sobre nós</Link>
                            </Fade>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;